import styled from '@emotion/styled'
import React from 'react'
import parabolMark from '../../../../styles/theme/images/brand/mark-color.svg'
import {ContactInfo} from '../../../../types/constEnums'

const Footer = styled('div')({
  textAlign: 'center'
})

const Heading = styled('div')({
  fontSize: 20,
  fontWeight: 600,
  lineHeight: '24px'
})

const Copy = styled('div')({
  fontSize: 14,
  lineHeight: '20px'
})

const Lockup = styled('img')({
  display: 'block',
  margin: '48px auto 16px',
  width: 64
})

const FinePrint = styled('div')({
  fontSize: 12,
  lineHeight: '1.5',
  margin: '16px auto 0'
})

const InvoiceFooter = () => {
  return (
    React.createElement(Footer, null
      , React.createElement(Heading, null, 'Thank you for using Parabol!')
      , React.createElement(Copy, null
        , 'Questions? Concerns?'
        , React.createElement('br', null )
        , 'Get in touch: '
        , React.createElement('a', { href: "mailto:billing@parabol.co", title: "Contact Us" ,}
          , React.createElement('b', null, ContactInfo.EMAIL_BILLING)
        )
      )
      , React.createElement(Lockup, { crossOrigin: "", alt: "Logo for Parabol"  , src: parabolMark,} )
      , React.createElement(FinePrint, null
        , 'Parabol, Inc.'
        , React.createElement('br', null )
        , '8605 Santa Monica Blvd'
        , React.createElement('br', null )
        , 'West Hollywood, CA 90069-4109'
        , React.createElement('br', null )
        , 'United States'
        , React.createElement('br', null )
        , React.createElement('a', {
          href: `tel:${ContactInfo.TELEPHONE.replace('-', '')}`,
          title: `Call us: ${ContactInfo.TELEPHONE}`,}

          , ContactInfo.TELEPHONE
        )
        , React.createElement('br', null )
        , React.createElement('a', { href: `mailto:${ContactInfo.EMAIL_LOVE}`, title: `Email us: ${ContactInfo.EMAIL_LOVE}`,}
          , ContactInfo.EMAIL_LOVE
        )
      )
    )
  )
}

export default InvoiceFooter
